import * as React from 'react';
import { ChangeEvent, Component } from 'react';
import { TBreakpoint as Breakpoint} from '../App';
import { Input } from 'reactstrap';
import Label from 'reactstrap/lib/Label';
import InputGroup from 'reactstrap/lib/InputGroup';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import FontAwesome from 'react-fontawesome';
import Help from './Help';
import './BreakpointRow.css';

interface Props {
    breakpoint: Breakpoint;
    onBreakpointChange?: (b: Breakpoint) => void;
    showHelp: boolean;
    disabled: boolean;
}

interface State {
    breakpoint: Breakpoint;
}

class BreakpointRow extends Component<Props, State> {
    constructor(p: Props) {
        super(p);
        this.state = {
            breakpoint: p.breakpoint
        };
    }

    onChange(name: string, e: ChangeEvent<HTMLInputElement>) {
        const newBreakpoint = {
            ...this.props.breakpoint
        };

        let val;
        switch (e.target.type) {
            case 'text':
                val = e.target.value;
                break;
            case 'number':
                val = parseInt(e.target.value, 10);
                break;
            case 'checkbox':
                val = e.target.checked;
                break;
            default:
                val = e.target.value;
        }

        // @ts-ignore
        newBreakpoint[name] = val;
        this.setState({
            breakpoint: newBreakpoint
        });
        if (this.props.onBreakpointChange) {
            this.props.onBreakpointChange(newBreakpoint);
        }
    }

    render() {
        const b = this.props.breakpoint;
        const showHelp = this.props.showHelp;
        const disabled = this.props.disabled;
        const disabledSizes = this.state.breakpoint.asis || this.state.breakpoint.hide;
        const disabledUrl = this.state.breakpoint.hide;

        return (
            <Row className="pb-4">
                <Col md={1} className={'text-center'}>
                    <div className={'w-100'}>
                        <FontAwesome
                            name={b.displayName ? b.displayName.toLowerCase() : ''}
                            size={'3x'}
                        />
                    </div>
                    <Label for={`url-${b.name}`}>{b.displayName || b.name}</Label>
                </Col>
                <Col md={2}>
                    <InputGroup className={'mr-2 mb-1'}>
                        <div className={'input-group-prepend'}>
                            <span className={'input-group-text prepend-text'}>Width</span>
                        </div>
                        <Input
                            disabled={disabled || disabledSizes}
                            type={'number'}
                            name="width"
                            onChange={(e) => this.onChange('width', e)}
                            className="size-input"
                            min={0}
                        />

                    </InputGroup>
                    <InputGroup>
                        <div className={'input-group-prepend'}>
                            <span className={'input-group-text prepend-text'}>Height</span>
                        </div>
                        <Input
                            disabled={disabled || disabledSizes}
                            type={'number'}
                            name="height"
                            onChange={(e) => this.onChange('height', e)}
                            className="size-input"
                            min={0}
                        />
                    </InputGroup>
                </Col>
                <Col md={1} className="text-center">
                    <div className="pl-2 options-col">
                        <div>
                            <Label check={true} className={'checkbox-with-help'}>
                                <Input
                                    disabled={disabled}
                                    className="position-static mr-1"
                                    type="checkbox"
                                    name="asis"
                                    onChange={(e) => this.onChange('asis', e)}
                                />{' '}
                                As Is
                                {showHelp &&
                                <Help id={`help-${b.name}-asis`}>
                                    Serves original image through CDN
                                </Help>
                                }

                            </Label>
                        </div>
                        <div>
                            <Label check={true} className={'checkbox-with-help'}>
                                <Input
                                    disabled={disabled}
                                    className="position-static mr-1"
                                    type="checkbox"
                                    name="hide"
                                    onChange={(e) => this.onChange('hide', e)}
                                />{' '}
                                Hide
                                {showHelp &&
                                <Help id={`help-${b.name}-hide`}>
                                    Hides image for the device
                                </Help>
                                }

                            </Label>
                        </div>
                    </div>
                </Col>
                <Col>
                    <div className="image-url-col">
                        <Input
                            disabled={disabled || disabledUrl}
                            id={`url-${b.name}`}
                            type={'textarea'}
                            value={b.url}
                            name="url"
                            onChange={(e) => this.onChange('url', e)}
                        />
                        {showHelp &&
                        <Help id={`help-${b.name}-url`}>
                            URL of the image for specific device type
                        </Help>
                        }
                    </div>
                </Col>
            </Row>);
    }
}

export default BreakpointRow;